import React from "react";
import { Link } from "react-router-dom"; // Changed from "react-router"
import { Breadcrumbs, ThemeProvider } from "@material-tailwind/react";
import { IoHome } from "react-icons/io5";

interface BreadCrumbPath {
  id: number;
  pathLink: string;
  pathName: string;
}

interface BreadcrumbsComponentProps {
  breadCrumbsPath: BreadCrumbPath[]; // Fixed casing to follow conventions
}

const theme = {
  breadcrumbs: {
    defaultProps: {
      className: "slick_title",
      fullWidth: false,
      separator: "/",
    },
    styles: {
      base: {
        root: {
          initial: {
            width: "w-max",
          },
          fullWidth: { display: "block", width: "w-full" },
        },
        list: {
          display: "flex",
          flexWrap: "flex-wrap",
          alignItems: "items-center",
          width: "w-full",
          bg: "none",
          bgOpacity: "bg-opacity-60",
          py: "py-1",
          px: "px-0",
          borderRadius: "rounded-md",
        },
        item: {
          initial: {
            display: "flex",
            alignItems: "items-center",
            color: "text-blue-gray-900",
            fontSmoothing: "antialiased",
            fontFamily: "text_OpenSans-VariableFont_wdth",
            fontSize: "text-xs",
            fontWeight: "font-normal",
            lineHeight: "leading-normal",
            cursor: "cursor-pointer",
            transition: "transition-colors duration-300",
            hover: "hover:text-customMaroon-35",
          },
          disabled: {
            pointerEvents: "pointer-events-none",
          },
        },
        separator: {
          color: "text-blue-gray-500",
          fontSize: "text-sm",
          fontSmoothing: "antialiased",
          fontFamily: "font-sans",
          fontWeight: "font-normal",
          lineHeight: "leading-normal",
          px: "mx-2",
          pointerEvents: "pointer-events-none",
        },
      },
    },
  },
};

const BreadcrumbsComponent: React.FC<BreadcrumbsComponentProps> = ({
  breadCrumbsPath, // Changed prop name to follow conventions
}) => {
  return (
    <div className="w-full pt-2 flex flex-col justify-center items-center lg:mt-0 mt-20">
      <ThemeProvider value={theme}>
        <div className="self-start px-10 lg:px-20 font-bold">
          <Breadcrumbs
            placeholder={null}
          >
            <Link to="/" className="flex items-center">
              <IoHome size={18} className="text-green-600 Blinker-SemiBold" />
            </Link>
            {breadCrumbsPath.map((breadCrumb) => (
              <Link 
                key={breadCrumb.id} 
                to={breadCrumb.pathLink}
                className="text-[0.9rem] text-gray-600 hover:text-customMaroon-35 transition-colors duration-300"
              >
                {breadCrumb.pathName}
              </Link>
            ))}
          </Breadcrumbs>
        </div>
      </ThemeProvider>
      <div className="flex-1"></div>
    </div>
  );
};

export default BreadcrumbsComponent;

// import React from "react";
// import { Link } from "react-router";
// import { Breadcrumbs } from "@material-tailwind/react";
// import { ThemeProvider } from "@material-tailwind/react";

// const BreadcrumbsComponent = ({ BreadCrumbsPath }) => {
//   const theme = {
//     breadcrumbs: {
//       defaultProps: {
//         className: "slick_title",
//         fullWidth: false,
//         separator: "/",
//       },
//       styles: {
//         base: {
//           root: {
//             initial: {
//               width: "w-max",
//             },
//             fullWidth: { display: "block", width: "w-full" },
//           },
//           list: {
//             display: "flex",
//             flexWrap: "flex-wrap",
//             alignItems: "items-center",
//             width: "w-full",
//             bg: "none",
//             bgOpacity: "bg-opacity-60",
//             py: "py-1",
//             px: "px-0",
//             borderRadius: "rounded-md",
//           },
//           item: {
//             initial: {
//               display: "flex",
//               alignItems: "items-center",
//               color: "text-blue-gray-900",
//               fontSmoothing: "antialiased",
//               fontFamily: "text_OpenSans-VariableFont_wdth",
//               fontSize: "text-xs",
//               fontWeight: "font-normal",
//               lineHeight: "leading-normal",
//               cursor: "cursor-pointer",
//               transition: "transition-colors duration-300",
//               hover: "hover:text-customMaroon-35",
//             },
//             disabled: {
//               pointerEvents: "pointer-events-none",
//             },
//           },
//           separator: {
//             color: "text-blue-gray-500",
//             fontSize: "text-sm",
//             fontSmoothing: "antialiased",
//             fontFamily: "font-sans",
//             fontWeight: "font-normal",
//             lineHeight: "leading-normal",
//             px: "mx-2",
//             pointerEvents: "pointer-events-none",
//           },
//         },
//       },
//     },
//   };

//   return (
//     <>
//       <div className="w-full pt-2 flex flex-col justify-center items-center shadow-sm">
//         <ThemeProvider value={theme}>
//           <div className="self-start px-10 lg:px-20 font-bold">
//             <Breadcrumbs  placeholder={undefined} >
//               <Link to={"/"}>
//                 <span>Home</span>
//               </Link>
//               {BreadCrumbsPath.map((BreadCrumbsPath:any) => (
//                 <Link
//                   key={BreadCrumbsPath.id}
//                   to={`${BreadCrumbsPath.pathLink}`}
//                 >
//                   <span>{BreadCrumbsPath.pathName}</span>
//                 </Link>
//               ))}
//             </Breadcrumbs>
//           </div>
//         </ThemeProvider>
//       </div>
//       <div className="flex-1 border-b border-gray-300 "></div>
//     </>
//   );
// };

// export default BreadcrumbsComponent;
